<div *ngIf="!isLoggedIn && !isLoggingIn">
    <ols-login></ols-login>
</div>

<div *ngIf="isLoggedIn" class="login-info">
    <mat-icon>account_circle </mat-icon>
    <p qa="client-name">{{ clientFullName }}</p>
    <a (click)="logout()">Logout</a>
</div>

<div *ngIf="shownView === View.ADD_CARD && isLoggedIn">
    <ols-new-card
        (viewChange)="changeShownView($event)"
        [hasCardsOnFile]="cardsOnFile?.length > 0"
        [surchargeSettings]="surchargeSettings"
    ></ols-new-card>
</div>

<div *ngIf="shownView === View.CARDS_ON_FILE && (isLoggedIn || isLoggingIn)">
    <ols-saved-cards
        (viewChange)="changeShownView($event)"
        [cardsOnFile]="cardsOnFile"
        [isLoading]="isLoadingCardsOnFile || isLoggingIn || isLoading"
        [surchargeSettings]="surchargeSettings"
    ></ols-saved-cards>
</div>

<div
    class="purchase-agreement"
    skeletonData
    [showSkeleton]="isLoggingIn"
    placeholderWidth="100%"
    placeholderHeight="1rem"
    *ngIf="purchaseAgreement && (isLoggedIn || isLoggingIn)"
>
    By purchasing an online gift card you agree to our gift card policy:
    <br />
    {{ purchaseAgreement }}
</div>
